import { createFileRoute } from '@tanstack/react-router';

import UserFeed from '~/app/users/UserFeed';

export const Route = createFileRoute('/_app/home/users/')({
	beforeLoad: () => {
		return {
			getTitle: undefined
		};
	},
	component: UserFeed
});
